<template>
    <div class="tsa-conditionInputhV2" :class="clearable && inputValue ? 'active' : ''">
        <el-input :placeholder="placeholder" v-model="inputValue" @input="input" @keyup.native.enter="change" :maxlength="maxlength">
            <i slot="suffix" v-if="clearable" class="el-icon-circle-close" @click="close"></i>
        </el-input>
        <div class="search-btn" @click="change">
            <img src="@/assets/images/search.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: '请输入'
        },
        maxlength: {
            type: Number,
            default: 30
        },
        clearable: {
            type: Boolean,
            default: false
        },
        icon: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            inputValue: ''
        }
    },
    watch: {
        value (val) {
            this.inputValue = val
        }
    },
    created () {
        this.inputValue = this.value
    },
    methods: {
        input (e) {
            if (this.inputValue) {
                let inputValue = this.inputValue.trim()
                this.$emit('input', inputValue)
            } else {
                this.$emit('input', null)
            }
            
        },
        change () {
            if (this.inputValue) {
                let inputValue = this.inputValue.trim()
                this.$emit('input', inputValue)
                this.$emit('on-search', inputValue)
            } else {
                this.$emit('input', null)
                this.$emit('on-search', null)
            }
        },
        close () {
            this.$emit('input', null)
            this.$emit('on-search', null)
        },
    },
}
</script>

<style lang="scss" scoped>
    .tsa-conditionInputhV2 {
        display: flex;
        position: relative;
        &.active {
            &:hover {
                .el-icon-circle-close {
                    display: block!important;
                }
                .tsa-icon-search2 {
                    display: none;
                }
            }
        }
        :deep(.el-input) {
            .el-input__inner {
                font-size:  14px;
                color: #151B26;
                border: 1px solid #E8E9EB;
                border-radius: 6px;
                height: 32px;
                line-height: 32px;
                padding-right: 52px;
                &:focus {
                    border-color: #2468F2;
                }
                &::placeholder {
                    color: #B8BABF;
                }
            }
            .el-input__suffix {
                display: flex;
                align-items: center;
                margin-right: 32px;
                .el-input__suffix-inner {
                    .el-icon-circle-close {
                        cursor: pointer;
                        display: none;
                    }
                }
            }
        }
        .search-btn {
            position: absolute;
            top: 0;
            right: 0;
            width: 32px;
            height: 32px;
            overflow: hidden;
            background-color: #005CE6;
            border-top-right-radius: 6px;
            border-bottom-right-radius: 6px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            &:hover {
                background-color: #0350c3;
            }
            img {
                width: 15px;
                height: 15px;
            }
        }
    }
</style>